import React from "react";
import DhPowerBallResult from "./pages/domain/minigame/dhpowerball/DhPowerBallResult";
import MinigameBettingList from "./pages/domain/betting/MinigameBettingList";
import CasinoBettingList from "./pages/domain/betting/CasinoBettingList";
import SlotBettingList from "./pages/domain/betting/SlotBettingList";
import DhPowerLadderResult from "./pages/domain/minigame/dhpowerladder/DhPowerLadderResult";
import UserTreeView from "./pages/domain/user/UserTreeView";
import DhPowerBallOddList from "./pages/domain/minigame/dhpowerball/DhPowerBallOddList";
import DhPowerLadderOddList from "./pages/domain/minigame/dhpowerladder/DhPowerLadderOddList";
import GameUseSetting from "./pages/domain/games/GameUseSetting";
import DhPowerBallLevelSetting from "./pages/domain/minigame/dhpowerball/DhPowerBallLevelSetting";
import DhPowerLadderLevelSetting from "./pages/domain/minigame/dhpowerladder/DhPowerLadderLevelSetting";

const Dashboard = React.lazy(() => import("./pages/domain/dashboard/Dashboard"))
const UserCreate = React.lazy(() => import("./pages/domain/user/UserCreate"))
const UserList = React.lazy(() => import("./pages/domain/user/UserList"))
const UserListPartner = React.lazy(() => import("./pages/domain/user/UserListPartner"))
const UserAccept = React.lazy(() => import("./pages/domain/user/UserAccept"))
const CashHistory = React.lazy(() => import("./pages/domain/user/CashHistory"))
const UserPointList = React.lazy(() => import("./pages/domain/user/UserPointList"))
const UserHistory = React.lazy(() => import("./pages/domain/user/UserHistory"))
const LoginHistory = React.lazy(() => import("./pages/domain/user/LoginHistory"))
const LoginUserList = React.lazy(() => import("./pages/domain/user/LoginUserList"))
const UserMultiIpList = React.lazy(() => import("./pages/domain/user/UserMultiIpList"))
const BettingList = React.lazy(() => import("./pages/domain/betting/BettingList"))
const SportBettingList = React.lazy(() => import("./pages/domain/betting/SportBettingList"))
const CashInRequestList = React.lazy(() => import("./pages/domain/cash/CashInRequestList"))
const CashInList = React.lazy(() => import("./pages/domain/cash/CashInList"))
const CashWithdrawRequestList = React.lazy(() => import("./pages/domain/cash/CashWithdrawRequestList"))
const CashWithdrawList = React.lazy(() => import("./pages/domain/cash/CashWithdrawList"))
const AdminProcList = React.lazy(() => import("./pages/domain/cash/AdminProcList"))
const CashChangeHistory = React.lazy(() => import("./pages/domain/cash/CashChangeHistoryList"))
const SettlePartners = React.lazy(() => import("./pages/domain/settle/SettlePartners"))
const SettleUsers = React.lazy(() => import("./pages/domain/settle/SettleUsers"))
const SettleGames = React.lazy(() => import("./pages/domain/settle/SettleGames"))
const SettlePeriod = React.lazy(() => import("./pages/domain/settle/SettlePeriod"))
const SettleMonthly = React.lazy(() => import("./pages/domain/settle/SettleMonthly"))
const GameSportsList = React.lazy(() => import("./pages/domain/games/GameSportsList"))
const GameSettingManage = React.lazy(() => import("./pages/domain/games/GameSettingManage"))
const InplayGameManage = React.lazy(() => import("./pages/domain/games/InplayGameManage"))
const CustomerMemo = React.lazy(() => import("./pages/domain/board/CustomerMemoList"))
const CustomerOneToOne = React.lazy(() => import("./pages/domain/board/CustomerOneToOneList"))
const CustomerNotice = React.lazy(() => import("./pages/domain/board/CustomerNoticeList"))
const CustomerMacro = React.lazy(() => import("./pages/domain/board/CustomerMacro"))
const ConfigEvent = React.lazy(() => import("./pages/domain/config/ConfigEvent"))
const ConfigBank = React.lazy(() => import("./pages/domain/config/ConfigBank"))
const ConfigBankGrade = React.lazy(() => import("./pages/domain/config/ConfigBankGrade"))
const ConfigDomain = React.lazy(() => import("./pages/domain/config/ConfigDomain"))
const ConfigPopup = React.lazy(() => import("./pages/domain/config/ConfigPopup"))
const ConfigInspection = React.lazy(() => import("./pages/domain/config/ConfigInspection"))
const ConfigOption = React.lazy(() => import("./pages/domain/config/ConfigOption"))
const ConfigBlock = React.lazy(() => import("./pages/domain/config/ConfigBlock"))
const AdminList = React.lazy(() => import("./pages/domain/admin/AdminList"))
const AdminJoinIpList = React.lazy(() => import("./pages/domain/admin/AdminJoinIp"))
const AdminLogs = React.lazy(() => import("./pages/domain/admin/AdminLogs"))
const SiteSetting = React.lazy(() => import("./pages/domain/config/SiteSetting"))
const ConfigSiteUserLevel = React.lazy(() => import("./pages/domain/config/LevelSetting"))
const LogViewer = React.lazy(() => import("./pages/domain/config/LogViewer"))
const MessageSend = React.lazy(() => import("./pages/domain/message/MessageSend"))
const MessageList = React.lazy(() => import("./pages/domain/message/MessageList"))
const PartnerChange = React.lazy(() => import("./pages/domain/partner/PartnerChange"))
const StatisticsDaily = React.lazy(() => import("./pages/domain/statistics/StatisticsDaily"))
const MinigameCloseSetting = React.lazy(() => import("./pages/domain/minigame/MinigameCloseSetting"))
const EventList = React.lazy(() => import("./pages/domain/event/EventLlist"))
const AttendanceList = React.lazy(() => import("./pages/domain/board/AttendanceList"))
const CouponTemplateList = React.lazy(() => import("./pages/domain/coupon/CouponTemplateList"))
const CouponIssue = React.lazy(() => import("./pages/domain/coupon/CouponIssue"))
const CouponHistory = React.lazy(() => import("./pages/domain/coupon/CouponHistory"))

const routes = [
	{path: "/", element: Dashboard},
	{path: "/dashboard", element: Dashboard},

	{path: "/admin/list", element: AdminList},
	// {path: "/partner/list2", element: PartnerList2},
	// {path: "/partner/create", element: PartnerCreate},

	// 회원관리
	{path: "/user/create", element: UserCreate},
	{path: "/user/list", element: UserList},
	{path: "/user/list-partner", element: UserListPartner},
	{path: "/user/accept", element: UserAccept},
	{path: "/user/cash-history", element: CashHistory},
	{path: "/user/point", element: UserPointList},
	{path: "/user/login/history", element: LoginHistory},
	{path: "/user/history", element: UserHistory},
	{path: "/user/login-user", element: LoginUserList},
	{path: "/user/multi-ip", element: UserMultiIpList},
	{path: "/user/tree-view", element: UserTreeView},

	{path: "/cash/in-request", element: CashInRequestList},
	{path: "/cash/in-list", element: CashInList},
	{path: "/cash/withdraw-request", element: CashWithdrawRequestList},
	{path: "/cash/withdraw-list", element: CashWithdrawList},

	// 관리자 지급/회수
	{path: "/cash/admin", element: AdminProcList},

	{path: "/cash/change-history", element: CashChangeHistory},
	{path: "/settle/partner-list1", element: SettlePartners},
	{path: "/settle/partner-list2", element: SettlePartners},
	{path: "/settle/user-list", element: SettleUsers},
	{path: "/settle/game-list", element: SettleGames},
	{path: "/settle/daily", element: SettlePeriod},
	{path: "/settle/monthly", element: SettleMonthly},
	{path: "/game/sports", element: GameSportsList},
	{path: "/game/setting", element: GameSettingManage},
	{path: "/game/inplay-setting", element: InplayGameManage},
	{path: "/customer/memo", element: CustomerMemo},
	{path: "/customer/inquiry", element: CustomerOneToOne},
	{path: "/customer/notice", element: CustomerNotice},
	{path: "/customer/macro", element: CustomerMacro},
	{path: "/customer/attendance", element: AttendanceList},

	// 쿠폰 관리
	{path: "/coupon/template", element: CouponTemplateList},
	{path: "/coupon/issue", element: CouponIssue},
	{path: "/coupon/history", element: CouponHistory},

	// 설정
	// 게임사용설정
	{path: "/config/use/all", element: GameUseSetting},

	{path: "/config/event", element: ConfigEvent},
	{path: "/config/default-bank", element: ConfigBank},
	{path: "/config/bank-grade", element: ConfigBankGrade},
	{path: "/config/domain", element: ConfigDomain},
	{path: "/config/inspection", element: ConfigInspection},
	{path: "/config/option", element: ConfigOption},
	{path: "/config/popup", element: ConfigPopup},
	{path: "/config/block", element: ConfigBlock},
	{path: "/admin/list", element: AdminList},
	{path: "/admin/ip-list", element: AdminJoinIpList},
	{path: "/admin/logs", element: AdminLogs},
	{path: "/config/site", element: SiteSetting},
	{path: "/config/level", element: ConfigSiteUserLevel},
	{path: "/config/log", element: LogViewer},

	// 배팅내역
	{path: "/betting/list", element: BettingList},
	{path: "/betting/sport/list", element: SportBettingList},
	{path: "/betting/minigame/list", element: MinigameBettingList},
	{path: "/betting/casino/list", element: CasinoBettingList},
	{path: "/betting/slot/list", element: SlotBettingList},

	// 미니게임
	{path: "/minigame/close", element: MinigameCloseSetting},
	{path: "/minigame/dhpowerball/result", element: DhPowerBallResult},
	{path: "/minigame/dhpowerball/odds", element: DhPowerBallOddList},
	{path: "/minigame/dhpowerball/setting", element: DhPowerBallLevelSetting},
	{path: "/minigame/dhpowerladder/result", element: DhPowerLadderResult},
	{path: "/minigame/dhpowerladder/odds", element: DhPowerLadderOddList},
	{path: "/minigame/dhpowerladder/setting", element: DhPowerLadderLevelSetting},

	{path: "/deposit", element: CashInList},
	{path: "/withdraw", element: CashWithdrawList},
	{path: "/point", element: UserPointList},
	{path: "/message/send", element: MessageSend},
	{path: "/message/list", element: MessageList},
	{path: "/partner/change", element: PartnerChange},
	{path: "/statistics/daily", element: StatisticsDaily},

	{path: "/event/list", element: EventList}
]

export default routes;